import { render, staticRenderFns } from "./AlternativeDistributionSpecificPercentages.vue?vue&type=template&id=7b404e3c"
import script from "./AlternativeDistributionSpecificPercentages.vue?vue&type=script&lang=js"
export * from "./AlternativeDistributionSpecificPercentages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports